import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, useHistory, useLocation } from 'react-router-dom';

import { checkAuthTokenExpiry } from 'helper/utility';
import OnBoarding from 'layouts/V2/OnBoarding';
import PropTypes from 'prop-types';

const LoginRoute = ({ path, exact, ComponentNew, type, ...props }) => {
    const history = useHistory();
    const location = useLocation();

    const isAuthUser = useSelector((state) => state?.auth?.userData?.token);
    const tokenExpireTime = useSelector(
        (state) => state.auth?.userData?.user.token_expiration_date
    );

    useEffect(() => {
        checkAuthTokenExpiry({ history, tokenExpireTime });
    }, [history, tokenExpireTime]);
    return (
        <Route
            path={path}
            exact={exact}
            render={() =>
                isAuthUser ? (
                    <Redirect to={'/dashboard' + location.search} />
                ) : (
                    <OnBoarding>
                        <ComponentNew {...props} type={type} />
                    </OnBoarding>
                )
            }
        />
    );
};

LoginRoute.propTypes = {
    path: PropTypes.string,
    exact: PropTypes.bool,
    ComponentNew: PropTypes.elementType,
    type: PropTypes.string,
};

export default LoginRoute;
